import React from 'react';

// Firebase
import { db } from "../../firebaseConfig";

// global
import { useAuth } from '../../AuthContext';

// redux
import { useAppSelector } from '../../redux/store';

// function fetchCallData
import { fetchCallMetrics } from './Function';
import { start } from 'repl';
import getCurrentScreen from '../../Helper/GetScreen';

interface UserOption {
  id: string;
  name: string;
}

interface CallDistributionProps {
  // Add props here
  users: UserOption[];
  selectedUser: UserOption[];
  startTime: string | null;
  endTime: string | null;
}

interface CallMetrics {
  outboundCalls: number;
  missedCalls: number;
  connected: number;
  inboundCalls: number;
  outboundDuration: number;  // in seconds
  inboundDuration: number;   // in seconds
  totalDuration: number;     // in seconds
  durationZero: number;
  durationNotZero: number;
  callAttemptTarget: number;
}

const OutboundCalls: React.FC<CallDistributionProps> = ({ users, selectedUser, startTime, endTime }) => {

  const { userData, currentUser, isAdmin, isManager, isStaff } = useAuth();
  const currentScreen = getCurrentScreen(useAppSelector(state => state.screen.currentScreen), isAdmin, isManager, isStaff);
  
  // data state
  const [callMetrics, setCallMetrics] = React.useState<CallMetrics>();

  // Function to check if it's a single day selection
  const isSingleDay = () => {
    if (!startTime || !endTime) return false;
    
    // Extract date part only (YYYY-MM-DD) to compare dates without time
    const startDate = startTime.split('T')[0];
    const endDate = endTime.split('T')[0];
    
    return startDate === endDate;
  };

  // Function to check if target should be shown
  const shouldShowTarget = () => {
    return isSingleDay();
  };

  React.useEffect(() => {
    fetchCallMetrics({ db, userData, startTime: startTime || null, endTime: endTime || null, users, currentScreen, selectedUser })
      .then((data) => { setCallMetrics(data); })
      .catch((error) => console.error("Error fetching call logs:", error));
  }, [userData?.companyId, startTime, endTime, users, currentScreen, selectedUser]);

  return (
    <div className=" bg-white">
      <div className="border border-cyan-600 rounded-lg p-2 mb-2">
        <h2
          className="text-xl text-black font-medium text-center mb-2"
          style={{
            fontFamily: "Montserrat",
            lineHeight: "29.26px",
          }}
        >Outbound Calls</h2>
        <div className="">
          <div className="bg-gray-100 mb-2  py-1 px-2 rounded-2xl relative">
            <div className="absolute left-0 rounded-tl-full rounded-br-full top-0 h-full w-6 bg-indigo-300 to-transparent" />
            <div className="relative px-5 text-center ">
              <div className="text-gray-600 text-base">Attempted:</div>
              <div className="font-semibold ">
                {shouldShowTarget() && callMetrics?.callAttemptTarget && callMetrics.callAttemptTarget > 0 ? (
                  <>{callMetrics?.outboundCalls}/{callMetrics.callAttemptTarget}</>
                ) : (
                  callMetrics?.outboundCalls
                )}
              </div>
            </div>
          </div>
          <div className="bg-gray-100  py-1 px-2 rounded-2xl relative">
            <div className="absolute right-0 rounded-tr-full rounded-bl-full top-0 h-full w-6 bg-cyan-600 to-transparent" />
            <div className="relative px-5 text-center ">
              <div className="text-gray-600 text-base">Connected:</div>
              <div className="font-semibold">{callMetrics?.connected}</div>
            </div>
          </div>
        </div>
      </div>

      {/* Inbound Calls Section */}
      <div className="border border-cyan-600 rounded-lg px-2 py-1 ">
        <h2
          className="text-xl text-black font-medium text-center mb-2"
          style={{
            fontFamily: "Montserrat",
            lineHeight: "29.26px",
          }}
        >Inbound Calls</h2>
        <div className="">
          <div className="bg-gray-100 mb-2  py-1 px-2 rounded-2xl relative">
            <div className="absolute left-0 rounded-tl-full rounded-br-full top-0 h-full w-6 bg-sky-950 to-transparent" />
            <div className="relative px-5 text-center ">
              <div className="text-gray-600 text-base">Received:</div>
              <div className="font-semibold">{callMetrics?.inboundCalls}</div>
            </div>
          </div>
          <div className="bg-gray-100  py-1 px-2 rounded-2xl relative">
            <div className="absolute right-0 rounded-tr-full rounded-bl-full top-0 h-full w-6 bg-red-500 to-transparent" />
            <div className="relative px-5 text-center ">
              <div className="text-gray-600 text-base">Missed:</div>
              <div className="font-semibold">{callMetrics?.missedCalls}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OutboundCalls;